<template>
  <div>
    <div class="all_body">
      <div class="new_content">
        <div class="news_left">
          <div class="news_left_nav" :class="{'category':category == 2}"  @click="getList(2)">新闻动态</div>
          <div class="news_left_nav" :class="{'category':category == 107}"  @click="getList(107)">政策头条</div>
          <div class="news_left_nav" :class="{'category':category == 100}"  @click="getList(100)">养殖宝典</div>
          <div class="news_left_nav" :class="{'category':category == 78}"  @click="getList(78)">微周报</div>
        </div>

        <div class="news_right">
          <div class="news_right_content" v-for="(item, index) in news_list" :key="index">
            <div class="news_right_content_title" @click="getDetail(item.cms_id)">{{item.cms_title}}</div>
            <div class="news_right_content_bottom">
              <div class="author">{{item.author}}</div>
              <div class="create_time">{{item.create_time}}</div>
              <img :src="play" class="play1" />
              <div class="news_right_bottom_font">{{item.view}}</div>
              <img :src="icon" class="icon1" />
              <div class="news_right_bottom_font">38</div>
            </div>
          </div>
          <div class="loadmore" @click="loadMore">点击加载更多</div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import MugenScroll from "vue-mugen-scroll";
import { newsData } from "../api/api";
export default {
  name: "News",
  components: { MugenScroll },
  data() {
    return {
      play: "./static/img/play.png",
      icon: "./static/img/icon.png",
      news_list: [],
      category: "",
      loading: false,
      page: 1,
      active: 2,
      newsNav: ""
    };
  },
  mounted() {
    this.category = this.$route.params.nav 
    this.$store.commit("settab", 1)
    newsData({
      page: 1,
      category: this.category,
      ticket: this.$store.state.ticket
    }).then(res => {
      this.news_list = res.data.data;
    });
  },
  methods: {
    getList(e) {
      newsData({
        page: 1,
        category: e,
        ticket: this.$store.state.ticket
      }).then(res => {
        this.news_list = res.data.data;
      });
      this.category = e;
      this.page = 1
    },

    loadMore(){
      this.page++;
      newsData({
        page: this.page,
        category: this.category,
        ticket: this.$store.state.ticket
      }).then(res => {
        for(var i=0; i < res.data.data.length; i++){
          this.news_list.push(res.data.data[i]);
        }
      });
    },

    getDetail(id){
      this.$router.push('/NewsDetail/'+ id)
    }
  }
};
</script>

<style>
.all_body {
  width: 100%;
  padding-left: 11%;
  padding-right: 10%;
}
.new_content {
  display: flex;
  margin-top: 50px;
  width: 100%;
  margin-bottom: 50px;
}
.news_left {
  width:260px;
}
.news_right {
  width: 900px;
  margin-left: 80px;
}
.news_left_nav {
  width: 100%;
  height: 120px;
  line-height: 120px;
  background: #EDEDED;
  opacity: 0.7;
  text-align: center;
  margin-bottom: 5px;
  font-size: 20px;
  font-weight: 200;
  cursor: pointer;
}
.category{
  background: #C0C0C0;
}
.news_right_content {
  width: 900px;
  border-bottom: 1px solid #b5b5b5;
  padding: 20px 0;
  padding-left: 10px;
}
.news_right_content_title {
  height: 30px;
  line-height: 30px;
  font-size: 30px;
  color: #000000;
  margin-bottom: 25px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}
.news_right_content_bottom {
  height: 17px;
  line-height: 17px;
  font-size: 14px;
  color: #000000;
  display: flex;
}
.play1 {
  width: 19px;
  height: 19px;
  line-height: 19px;
  opacity: 0.3;
  margin-right: 10px;
  margin-top: 0;
}
.icon1 {
  width: 20px;
  height: 19px;
  line-height: 19px;
  opacity: 0.2;
  margin-right: 10px;
  margin-left: 20px;
  margin-top: 0;
}
.author {
  padding-right: 30px;
  font-size: 18px;
}
.create_time {
  padding-right: 56px;
  font-size: 18px;
}
.loadmore{
  width: 900px;
  text-align: center;
  color: #000000;
  font-size: 22px;
  height: 30px;
  line-height: 30px;
  margin-top: 20px;
  cursor: pointer;
}
.news_right_bottom_font{
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/News.vue